export default {
  methods: {
    tzktLink(contractOrOp){
      if (this.$store.isSandbox){
        return `https://bcd.hover.engineering/sandboxnet/opg/${contractOrOp}`
      } else {
        return `https://${this.$store.network === 'mainnet' ? '' : this.$store.network + '.'}tzkt.io/${contractOrOp}`
      }
    },
    bcdLink(contract){
      if (this.$store.network === 'granadanet'){
        return `https://better-call.dev/granadanet/${contract}`
      } else if (this.$store.isSandbox) {
        return `https://bcd.hover.engineering/sandboxnet/${contract}`
      } else {
        return `https://better-call.dev/mainnet/${contract}`
      }
    },
    numberWithCommas(x) {
      let parts = x.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    }
  },
  computed: {

  },
  data() {
    return {
      proposalStates: {
        0: {
          cssClass: 'failed',
          tagClass: 'is-danger',
          humanReadable: 'Failed',
        },
        1: {
          cssClass: 'timelock',
          tagClass: 'is-info',
          humanReadable: 'Waiting In Timelock',
        },
        2: {
          cssClass: 'executed',
          tagClass: 'is-primary',
          humanReadable: 'Executed Successfully',
        },
        3: {
          cssClass: 'cancelled',
          tagClass: 'is-danger',
          humanReadable: 'Cancelled Before Execution',
        },
        4: {
          cssClass: 'still-voting',
          tagClass: 'is-info',
          humanReadable: 'Currently Voting',
        },
      }
    }
  }
}
